import { Toast } from 'antd-mobile';
import React from 'react';
import {
  fishingActivityMainInfo,
  fishingActivityGuideInfo,
  fishingActivityNextInfo,
  fishingActivityNormalFishing,
  fishingActivityBigFishing,
  fishingActivityCurrentInfo,
  fishingActivityAchievementList,
  fishingActivityReceiveAchievementReward,
  fishingActivityFishingHistory,
  fishingActivityAquariumInfo,
  fishingActivityCollectAquarium,
  fishingActivityGetRank,
  fishingActivityGetTaskInfo,
  fishingActivityDealTask,
  fishingActivityExchangeList,
  fishingActivityExchange,
  fishingActivityClickRules,
} from '@/services/activity';

// import { mockMainInfo, mockGuideInfo, mockFishingNormalInfo, mockFishingBiglInfo, mockCurrentInfo } from '../mock';

export default {
  namespace: 'fishingActivity',
  state: {
    activityId: 1,
    status: 1,
    countDown: 0,
    title: '',
    titleUrl: '',
    rules: '',
    canToUserInfo: false,
    trapNum: 0,
    bombNum: 0,
    staminaValue: 0,
    rodCostStamina: 0,
    currentGuideStep: 0,
    bigFishInfo: {}, // 钓到大鱼时的信息
    fishingRewards: [], // 钓鱼奖励
    bombCountDown: 0,
    userInfo: {},
    achievementInfo: {},
    fishCount: 0,
    ticketNum: 0,
    showStoreRedPoint: false,
    showGalleryRedPoint: false,
    showStarRedPoint: false,
    showTaskRedPoint: false,
    holdFishCount: 0,
    achievementList: [],
    aquariumInfo: {},
    activityDays: [],
    currentDay: {},
    selfInfo: {},
    ranks: [],
    lastId: '',
    taskInfoList: [],
    shopItemList: [],
    pageNum: 1,
    pageSize: 10,
    isMore: false,
    recordList: [],
  },
  reducers: {
    updateInfo(state, { payload }) {
      return {
        ...state,
        activityId: payload.activityId || 1,
        status: payload.status || 0,
        countDown: payload.countDown || 0,
        title: payload.title || '',
        titleUrl: payload.titleUrl || '',
        rules: payload.rules || '',
        canToUserInfo: payload.canToUserInfo || false,
      };
    },
    updateCurrentInfo(state, { payload }) {
      return {
        ...state,
        trapNum: payload.trapNum || 0,
        bombNum: payload.bombNum || 0,
        staminaValue: payload.staminaValue || 0,
        rodCostStamina: payload.rodCostStamina || 0,
        bombCountDown: payload.bombCountDown || 0,
        userInfo: payload.userInfo || {},
        achievementInfo: payload.achievementInfo || {},
        fishCount: payload.fishCount || 0,
        ticketNum: payload.ticketNum || 0,
        showStoreRedPoint: payload.showStoreRedPoint || false,
        showGalleryRedPoint: payload.showGalleryRedPoint || false,
        showStarRedPoint: payload.showStarRedPoint || false,
        showTaskRedPoint: payload.showTaskRedPoint || false,
        holdFishCount: payload.holdFishCount || 0,
      };
    },
    updateGuideInfo(state, { payload }) {
      return {
        ...state,
        currentGuideStep: payload.currentStep || 0,
        isDurationGuide: payload.isDurationGuide || false,
        bigFishInfo: payload.bigFishInfo || {},
        fishingRewards: payload.fishingRewards || [],
      };
    },
    updateBombInfo(state, { payload }) {
      return {
        ...state,
        bombCountDown: payload.bombCountDown || 0,
      };
    },
    updateBigFishingInfo(state, { payload }) {
      return {
        ...state,
        bigFishInfo: payload.bigFishInfo,
      };
    },
    updateAchievementList(state, { payload }) {
      return {
        ...state,
        achievementList: payload.achievementList || [],
      };
    },
    updateFishingHistory(state, { payload }) {
      let newList = payload.force ? [] : [...state.recordList];
      if (payload.records && payload.records.length) {
        newList = [...newList, ...payload.records];
      }
      return {
        ...state,
        recordList: newList,
        pageNum: payload.pageNum,
        isMore: newList.length < payload.total,
      };
    },
    updateAquariumInfo(state, { payload }) {
      return {
        ...state,
        aquariumInfo: payload || {},
      };
    },
    updateRankList(state, { payload }) {
      const { activityDays, currentDay, activityRankVO } = payload;
      const { selfInfo, ranks } = activityRankVO || {};
      let list = payload.force ? [] : [...state.ranks];
      let lastId = '';
      if (ranks && ranks.length) {
        list = [...list, ...ranks];
        lastId = ranks[ranks.length - 1].userId;
      }
      return {
        ...state,
        activityDays: activityDays || [],
        currentDay: currentDay || {},
        selfInfo: selfInfo || {},
        ranks: list,
        lastId: lastId,
      };
    },
    updateTaskInfo(state, { payload }) {
      return {
        ...state,
        taskInfoList: payload.taskInfoList || [],
      };
    },
    updateExchangeList(state, { payload }) {
      return {
        ...state,
        shopItemList: payload.shopItemList || [],
      };
    },
  },
  effects: {
    *getInfo({ payload }, { call, put }) {
      const { error, data } = yield call(fishingActivityMainInfo, payload);
      // yield put({
      //   type: 'updateInfo',
      //   payload: mockMainInfo,
      // });
      // return mockMainInfo;
      if (error || !data) {
        yield put({
          type: 'updateInfo',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: <div dangerouslySetInnerHTML={{ __html: error }}></div>,
          });
        }
        return false;
      }
      yield put({
        type: 'updateInfo',
        payload: data,
      });
      return data;
    },
    *getCurrentInfo({ payload }, { call, put }) {
      const { error, data } = yield call(fishingActivityCurrentInfo, payload);
      // yield put({
      //   type: 'updateCurrentInfo',
      //   payload: mockCurrentInfo,
      // });
      // return mockCurrentInfo;
      if (error || !data) {
        yield put({
          type: 'updateCurrentInfo',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: <div dangerouslySetInnerHTML={{ __html: error }}></div>,
          });
        }
        return false;
      }
      yield put({
        type: 'updateCurrentInfo',
        payload: data,
      });
      // 更新大鱼信息
      if (data.bigFishInfo) {
        yield put({
          type: 'updateBigFishingInfo',
          payload: data,
        });
      }
      return data;
    },
    // 引导页面初始化中途退出时记录步骤
    *getGuideInfo({ payload }, { call, put }) {
      const { error, data } = yield call(fishingActivityGuideInfo, payload);
      // yield put({
      //   type: 'updateGuideInfo',
      //   payload: mockGuideInfo,
      // });
      // return mockGuideInfo;
      if (error || !data) {
        yield put({
          type: 'updateGuideInfo',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: <div dangerouslySetInnerHTML={{ __html: error }}></div>,
          });
        }
        return false;
      }
      // 引导页期间更新初始化数据
      if (data && data.isDurationGuide) {
        yield put({
          type: 'updateGuideInfo',
          payload: data,
        });
      }
      return data;
    },
    // 正常流程下引导执行的步骤
    *updateGuideStep({ payload }, { call, put }) {
      const { error, data } = yield call(fishingActivityNextInfo, payload);
      // const newData = {
      //   ...mockGuideInfo,
      //   currentStep: payload.currentGuideStep + 1,
      // };
      // yield put({
      //   type: 'updateGuideInfo',
      //   payload: newData,
      // });
      // return newData;
      if (error || !data) {
        if (error) {
          Toast.show({
            content: <div dangerouslySetInnerHTML={{ __html: error }}></div>,
          });
        }
        return false;
      }
      yield put({
        type: 'updateGuideInfo',
        payload: data,
      });
      // 只有第12步走这个流程，其余情况下不需要
      if (data && data.isDurationGuide && data.currentStep && data.currentStep === 12) {
        yield put({
          type: 'updateBombInfo',
          payload: data,
        });
      }
      return data;
    },
    *updateFishing({ payload }, { call, put }) {
      const { error, data } = yield call(fishingActivityNormalFishing, payload);
      // yield put({
      //   type: 'updateBigFishingInfo',
      //   payload: mockFishingNormalInfo,
      // });
      // return mockFishingNormalInfo;
      if (error || !data) {
        if (error) {
          Toast.show({
            content: <div dangerouslySetInnerHTML={{ __html: error }}></div>,
          });
        }
        return false;
      }
      // 如果抽到大鱼时，需要更新大鱼信息
      yield put({
        type: 'updateBigFishingInfo',
        payload: data,
      });
      return data;
    },
    *updateBigFishing({ payload }, { call }) {
      const { error, data } = yield call(fishingActivityBigFishing, payload);
      // return mockFishingBiglInfo;
      if (error || !data) {
        if (error) {
          Toast.show({
            content: <div dangerouslySetInnerHTML={{ __html: error }}></div>,
          });
        }
        return false;
      }
      return data;
    },
    *getAchievementList({ payload }, { call, put }) {
      const { error, data } = yield call(fishingActivityAchievementList, payload);
      if (error || !data) {
        yield put({
          type: 'updateAchievementList',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: <div dangerouslySetInnerHTML={{ __html: error }}></div>,
          });
        }
        return false;
      }
      yield put({
        type: 'updateAchievementList',
        payload: data,
      });
      return data;
    },
    *receiveAchievementReward({ payload }, { call, put }) {
      const { error, data } = yield call(fishingActivityReceiveAchievementReward, payload);
      if (error || !data) {
        if (error) {
          Toast.show({
            content: <div dangerouslySetInnerHTML={{ __html: error }}></div>,
          });
        }
        return {
          success: false,
          error,
        };
      }
      return {
        success: true,
        data,
      };
    },
    *getFishingHistory({ payload }, { call, put, select }) {
      const { pageNum, pageSize } = yield select(state => state.fishingActivity);
      const { error, data } = yield call(fishingActivityFishingHistory, { ...payload, pageNum: payload.force ? 1 : pageNum, pageSize: pageSize, force: undefined });
      if (error || !data) {
        yield put({
          type: 'updateFishingHistory',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: <div dangerouslySetInnerHTML={{ __html: error }}></div>,
          });
        }
        return false;
      }
      yield put({
        type: 'updateFishingHistory',
        payload: { ...data, pageNum: payload.force ? 2 : pageNum + 1, force: payload.force },
      });
      return data;
    },
    *getAquariumInfo({ payload }, { call, put }) {
      const { error, data } = yield call(fishingActivityAquariumInfo, payload);
      if (error || !data) {
        yield put({
          type: 'updateAquariumInfo',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: <div dangerouslySetInnerHTML={{ __html: error }}></div>,
          });
        }
        return false;
      }
      yield put({
        type: 'updateAquariumInfo',
        payload: data,
      });
      return data;
    },
    *collectAquarium({ payload }, { call, put }) {
      const { error, data } = yield call(fishingActivityCollectAquarium, payload);
      if (error || !data) {
        if (error) {
          Toast.show({
            content: <div dangerouslySetInnerHTML={{ __html: error }}></div>,
          });
        }
        return {
          success: false,
          error,
        };
      }
      return {
        success: true,
        data,
      };
    },
    *getRankList({ payload }, { call, put, select }) {
      const { lastId } = yield select(state => state.fishingActivity);
      const { error, data } = yield call(fishingActivityGetRank, { ...payload, lastId: payload.force ? '' : lastId, force: undefined });
      if (error || !data) {
        yield put({
          type: 'updateRankList',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: <div dangerouslySetInnerHTML={{ __html: error }}></div>,
          });
        }
        return false;
      }
      yield put({
        type: 'updateRankList',
        payload: { ...data, force: payload.force },
      });
      return data;
    },
    *getTaskInfo({ payload }, { call, put }) {
      const { error, data } = yield call(fishingActivityGetTaskInfo, payload);
      if (error || !data) {
        yield put({
          type: 'updateTaskInfo',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: <div dangerouslySetInnerHTML={{ __html: error }}></div>,
          });
        }
        return false;
      }
      yield put({
        type: 'updateTaskInfo',
        payload: data,
      });
      return data;
    },
    *dealTask({ payload }, { call, put }) {
      const { error, data } = yield call(fishingActivityDealTask, payload);
      if (error || !data) {
        if (error) {
          Toast.show({
            content: <div dangerouslySetInnerHTML={{ __html: error }}></div>,
          });
        }
        return {
          success: false,
          error,
        };
      }
      return {
        success: true,
        data,
      };
    },
    *getExchangeList({ payload }, { call, put }) {
      const { error, data } = yield call(fishingActivityExchangeList, payload);
      if (error || !data) {
        yield put({
          type: 'updateExchangeList',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: <div dangerouslySetInnerHTML={{ __html: error }}></div>,
          });
        }
        return false;
      }
      yield put({
        type: 'updateExchangeList',
        payload: data,
      });
      return data;
    },
    *fishingExchange({ payload }, { call, put }) {
      const { error, data } = yield call(fishingActivityExchange, payload);
      if (error || !data) {
        if (error) {
          Toast.show({
            content: <div dangerouslySetInnerHTML={{ __html: error }}></div>,
          });
        }
        return {
          success: false,
          error,
        };
      }
      return {
        success: true,
        data,
      };
    },
    *clickRules({ payload }, { call, put }) {
      const { error, data } = yield call(fishingActivityClickRules, payload);
      if (error || !data) {
        if (error) {
          Toast.show({
            content: <div dangerouslySetInnerHTML={{ __html: error }}></div>,
          });
        }
        return {
          success: false,
          error,
        };
      }
      return {
        success: true,
        data,
      };
    },
  },
};
